<template>
    <div class="list-group" @click="$emit('click')">
        <div class="items">
            <div class="title">
                <img src="@/assets/img/special-subject-title.jpg" alt="" />
            </div>
            <div class="proItems">
                <div class="item disflex" v-for="i in 3" :key="i">
                    <div class="tips">今日特价</div>
                    <img class="shan" src="@/assets/img/img-icon.png" alt="" />
                    <div class="right">
                        <div>
                            <div class="title-tips">商品标题商品标题商品标题商品标题商品标题商品标题</div>
                            <div class="label-tips">热销0份</div>
                        </div>
                        <div class="price-box">
                            <div>
                                <span class="nprice">￥100/件</span>
                                <span>￥99</span>
                            </div>
                            <div class="icon-box">
                                <i class="el-icon-plus"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="delete-box">
            <div class="handleType">
                <div class="iconfont" @click="remove()">
                    <i class="el-icon-delete"></i>
                </div>
                <div class="iconfont">
                    <i class="el-icon-copy-document" @click="copy()"></i>
                </div>
                <div class="iconfont" :class="{ disabled: index === 0 }" @click="downward()">
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div class="iconfont" @click="upward()" :class="{ disabled: index >= finallyIndex }">
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
        </div>

        <div class="delete-name">必买清单</div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            default: null
        },
        finallyIndex: {
            type: Number,
            default: null
        }
    },
    methods: {
        remove() {
            this.$emit('remove', '');
        },
        copy() {
            this.$emit('copy', '');
        },
        downward() {
            this.$emit('downward', '');
        },
        upward() {
            this.$emit('upward', '');
        }
    }
};
</script>

<style lang="scss" scoped>
.on {
    scale: 1.01;
    .delete-box {
        display: block !important;
        border: 2px solid #0256ff !important;
        box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3) !important;
    }

    .delete-name {
        display: block !important;
        background: #4d88ff !important;
        color: #fff !important;
        &::before {
            background: #4d88ff !important;
        }
    }
}

.disabled {
    opacity: 0.4 !important;
}

.list-group:hover {
    scale: 1.01;
    box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3);
    transition: all 0.2s;
}

.disflex {
    display: flex;
}

.list-group {
    width: 100%;
    position: relative;
    transition: all 0.2s;
    padding: 10px 0;
    background: #79be87;

    .items {
        padding: 0 12px;
        .title {
            width: 100%;
            display: flex;
            align-items: center;
            & > img {
                width: 50%;
                margin: auto;
            }
        }

        .proItems {
            padding: 0 10px;
            margin-top: 20px;

            .item {
                // width: 100%;
                border-radius: 10px;
                background: #fff;
                position: relative;
                // padding: 20px 10px;
                padding-bottom: 5px;
                overflow: hidden;
                margin-bottom: 10px;
                .tips {
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: #ee6e2e;
                    padding: 5px;
                    color: #fff;
                }

                .shan {
                    margin-left: 30px;
                    width: 130px;
                    height: 150px !important;
                    background: #f3f9ff;
                }

                .right {
                    flex: 1;
                    padding: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .title-tips {
                        // font-weight: 500;
                        font-size: 15px;
                        /* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
                        display: -webkit-box;
                        /* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
                        -webkit-box-orient: vertical;
                        /*要显示的行数*/
                        -webkit-line-clamp: 2;
                        /* 溢出部分隐藏 */
                        overflow: hidden;
                    }

                    .label-tips {
                        color: #666;
                        font-size: 10px;
                        margin-top: 5px;
                    }

                    .price-box {
                        font-size: 14px;
                        color: #ccc;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .nprice {
                            font-weight: 600;
                            color: red;
                            margin-right: 15px;
                        }

                        .icon-box {
                            width: 18px;
                            height: 18px;
                            font-size: 12px;
                            border-radius: 100%;
                            background: red;
                            display: flex;
                            align-items: center;
                            color: #fff;
                            justify-content: center;
                        }
                    }
                }
            }
        }
    }

    .delete-name {
        position: absolute;
        top: 0;
        background: #fff;
        left: -100px;
        width: 86px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #666;
        border-radius: 3px;
        // display: none;

        &::before {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            background: #fff;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 50%;
            right: -5px;
            margin-top: -5px;
        }
    }

    .delete-box {
        display: none;
        position: absolute;
        left: -2px;
        top: 0;
        width: 375px;
        height: 100%;
        border: 2px dashed #0256ff;
        .handleType {
            position: absolute;
            right: -43px;
            top: 0;
            width: 36px;
            border-radius: 4px;
            background-color: #0256ff;
            cursor: pointer;
            color: #fff;
            font-weight: 700;
            text-align: center;
            padding: 4px 0;

            .iconfont {
                padding: 5px 0;
            }
        }
    }
}
</style>